import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class CampaignProductFilter extends Component {
    state = {
        CampaignProductLists:[],
        CampaignProductValue:null,
        CampaignProductLoading: true
    };
    componentDidMount(){
        this.get_campaign_product();
    }

    resetEmailFilter(){
        this.setState({
        CampaignProductValue: [],
        })
    }
     get_campaign_product(){
        axios.get(config.get('API_URL')+'/CampaignModule/get_campaign_products/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((product, index) => {
                    this.state.CampaignProductLists.push({value: product.product_code, label: product.product_display_name})
                });
            }
        });
     }
     changeCampaignProduct(optionSelected){
        let value='';
        let CampaignProductArray = [];
        if(optionSelected.length < 1){
            value = null;
            CampaignProductArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                CampaignProductArray.push(mids.value)
                var index = this.state.CampaignProductLists.findIndex(obj => obj.value==mids.value);
                this.state.CampaignProductLists.move(index,0).join(',');

            });
        }
        this.props.onSelectCampaignProduct(optionSelected,CampaignProductArray);
        this.setState({
            CampaignProductValue:optionSelected,
        });
    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="product"
            isMulti
            value={this.state.CampaignProductValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeCampaignProduct.bind(this)}
            options={this.state.CampaignProductLists}
            placeholderButtonLabel="Select [Product]"
        />
        );

    }
}
export default CampaignProductFilter;